import React, { useEffect, useState } from "react";

/**
 * What the copilot shows between "the data is on screen" and "the answer is
 * written".
 *
 * A turn streams its blocks first — a table lands, then the prose that explains
 * it arrives seconds later. The dots only covered the case where NOTHING had
 * rendered yet, so the gap after the table looked like the answer had finished
 * and simply had no commentary.
 *
 * The phrases rotate because one frozen "Working on it…" reads as stuck: a line
 * that changes is the difference between "still going" and "hung".
 */
const PHRASES = [
  "Reading the numbers",
  "Comparing with the previous period",
  "Looking for what stands out",
  "Checking which sequences moved",
  "Putting the summary together",
  "Almost there"
];

// Long enough to read, short enough that the line never looks frozen.
const ROTATE_MS = 2600;

const ComposingHint = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setIndex(current => (current + 1) % PHRASES.length),
      ROTATE_MS
    );
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="copilotComposing" role="status" aria-live="polite">
      <span className="copilotComposing__dots">
        <span className="copilotDot" />
        <span className="copilotDot" />
        <span className="copilotDot" />
      </span>
      {/* Keyed so each phrase fades in rather than swapping abruptly. */}
      <span className="copilotComposing__text" key={index}>
        {PHRASES[index]}
      </span>
    </div>
  );
};

export default ComposingHint;
